import Headline from "./index.vue";

Headline.install = Vue => Vue.component(Headline.componentName, Headline);

export default Headline;
